











import Vue from "vue";
import ReactButton from "./ReactButton.vue";

export default Vue.extend({
  props: ['model'],
  components: {'react-button' : ReactButton},
});
